var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.40716 11.8204L6.41205 8.88623H14V5.15569H6.41205L9.40716 2.22156L7.17137 0L0 7L7.17137 14L9.40716 11.8204Z","fill":"currentColor"}));
}

ArrowLeft.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
